export default "__VITE_ASSET__B$Muh_$S__"